import { metadata } from "./metadata.js";

export default { metadata };
